export const CUSTOMIZE_SPACE_TABS = [
  "overview",
  "lessons",
  "customize",
  "paywalls",
  "lock_screen",
  "members",
  "options",
  "workflows",
] as const;
